module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm2_normal.72e0a9be.png";